import { Expose, Type } from 'class-transformer';
import { FloorModel } from '../../../room/dto/models/floor.model';
import { EventResourceImplement } from './event-resource.implement';
import { BuildingWithLocationModel } from '../../../room/dto/implements/building-with-location.model';

export class EventResourceWithRelationsImpl extends EventResourceImplement {
  @Expose({ name: 'building' })
  @Type(() => BuildingWithLocationModel)
  building: BuildingWithLocationModel;
  @Expose({ name: 'floor' })
  @Type(() => FloorModel)
  floor: FloorModel;
}
